import axiosInstance from '../../axiosInstance';

const setArticlePreferredHomeSection = async ({
  articleId = 'none',
  preferredHomeSection = '',
}) => {
  const response = await axiosInstance.patch(
    `/api/admin/v2/articles/${articleId}/preferred-home-section`,
    {
      preferred_home_section: preferredHomeSection,
    },
  );

  const { data } = response.data;
  return data;
};

export default setArticlePreferredHomeSection;
